module.exports = __webpack_public_path__ + "img/phone-bg.ffbbd3c4.jpeg";